import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "shadow-edit__settings__item shadow-edit__settings__item--inline" }
const _hoisted_2 = { class: "shadow-edit__settings__title" }
const _hoisted_3 = { class: "shadow-edit__settings__content" }
const _hoisted_4 = {
  key: 0,
  class: "shadow-edit__settings__item mb-4"
}
const _hoisted_5 = { class: "shadow-edit__settings__title" }
const _hoisted_6 = { class: "shadow-edit__settings__content shadow-edit__settings__content--padding" }
const _hoisted_7 = { class: "shadow-edit__settings__item mb-4" }
const _hoisted_8 = { class: "shadow-edit__settings__title" }
const _hoisted_9 = { class: "shadow-edit__settings__content shadow-edit__settings__content--padding" }
const _hoisted_10 = { class: "shadow-edit__settings__item mb-4" }
const _hoisted_11 = { class: "shadow-edit__settings__title mb-0" }
const _hoisted_12 = { class: "shadow-edit__settings__content" }
const _hoisted_13 = { class: "shadow-edit__settings__padding" }
const _hoisted_14 = { class: "shadow-edit__settings__padding__item__text" }
const _hoisted_15 = { class: "shadow-edit__settings__padding__item__value" }
const _hoisted_16 = { class: "shadow-edit__settings__padding__item__text" }
const _hoisted_17 = { class: "shadow-edit__settings__padding__item__value" }
const _hoisted_18 = { class: "shadow-edit__settings__padding__item__value__row" }
const _hoisted_19 = { class: "shadow-edit__settings__padding__item__value__row__item" }
const _hoisted_20 = { class: "shadow-edit__settings__padding__item__value__row__item" }
const _hoisted_21 = { class: "shadow-edit__settings__padding__item__value__row" }
const _hoisted_22 = { class: "shadow-edit__settings__padding__item__value__row__item" }
const _hoisted_23 = { class: "shadow-edit__settings__padding__item__value__row__item" }
const _hoisted_24 = { class: "shadow-edit__settings__item shadow-edit__settings__item--inline" }
const _hoisted_25 = { class: "shadow-edit__settings__title" }
const _hoisted_26 = { class: "shadow-edit__settings__content" }
const _hoisted_27 = { class: "shadow-edit__settings__item" }
const _hoisted_28 = { class: "shadow-edit__settings__title" }
const _hoisted_29 = { class: "shadow-edit__settings__content" }
const _hoisted_30 = { class: "shadow-edit__settings__item shadow-edit__settings__item--inline" }
const _hoisted_31 = { class: "shadow-edit__settings__title" }
const _hoisted_32 = { class: "shadow-edit__settings__content" }

import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useEventBus } from '@vueuse/core';

import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';

import ColorsList from '@/components/common/ColorsList/ColorsList.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';
import CanvasSizes from '@/components/pages/Shadow/CanvasSizes/CanvasSizes.vue';
import PositionList from '@/components/pages/Shadow/PositionList/PositionList.vue';
import ShadowType from '@/components/pages/Shadow/ShadowType/ShadowType.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShadowSettings',
  setup(__props) {

const { t } = useI18n();

const busError = useEventBus<string>('toast-error');

const { generateImage } = useServicesStore();

const { isMobile } = storeToRefs(useCommonStore());
const {
  generationLoading,
  shadowParams,
  imageForActions,
  shadowParamsCanvasHeight,
  shadowParamsCanvasWidth,
  shadowParamsFormat,
  shadowParamsType,
  imagePrev,
  imageResult,
} = storeToRefs(useServicesStore());

const settingsTab = ref<'presets' | 'custom'>('custom');
const key = ref<number>(0);
const keyCustom = ref<number>(0);

const formats = computed(() => {
  let result = [{
    title: 'PNG',
    value: 0,
  }];
  if (shadowParams.value.shadowColor !== '') {
    result = [
      {
        title: 'JPEG',
        value: 1,
      },
      {
        title: 'PNG',
        value: 0,
      },
    ];
  }
  return result;
});

const setPadding = (index: number): void => {
  shadowParams.value.paddingIndex = index;
};

const shadowFileHandler = (): void => {
  generationLoading.value = true;

  let paddingInt = {};
  if (shadowParams.value.paddingIndex === -2) {
    paddingInt = {
      left_pad: shadowParams.value.paddingLeft,
      right_pad: shadowParams.value.paddingRight,
      bottom_pad: shadowParams.value.paddingBottom,
      top_pad: shadowParams.value.paddingTop,
    };
  } else if (shadowParams.value.paddingIndex === -1) {
    paddingInt = {
      left_pad: shadowParams.value.padding,
      right_pad: shadowParams.value.padding,
      bottom_pad: shadowParams.value.padding,
      top_pad: shadowParams.value.padding,
    };
  }

  generateImage({
    action: 'shadow',
    image: removeBase64Prefix(imageForActions.value),
    params: {
      form: shadowParamsFormat.value,
      mode: shadowParamsType.value,
      padding: paddingInt,
      shadow: shadowParams.value.isShadow,
      color: shadowParams.value.shadowColor === '' ? null : shadowParams.value.shadowColor,
      size: {
        height: shadowParamsCanvasHeight.value,
        width: shadowParamsCanvasWidth.value,
      },
    },
  })
    .then((res) => {
      imagePrev.value = imageForActions.value;
      imageForActions.value = `data:image/png;base64,${res.payload.imageWithPadding}`;
      imageResult.value = `data:image/png;base64,${res.image}`;
      // sourceShadowImg.value = `data:image/png;base64,${res.payload.imageWithPadding}`;
    })
    .catch((e) => {
      busError.emit(e?.error || t('common.err-gen'));
    })
    .finally(() => {
      generationLoading.value = false;
    });
};

watch(settingsTab, (newVal) => {
  if (newVal === 'presets') {
    key.value += 1;
  } else {
    keyCustom.value += 1;
    shadowParams.value.shadowColor = '#ffffff';
    shadowParams.value.paddingLeft = 0;
    shadowParams.value.paddingRight = 0;
    shadowParams.value.paddingBottom = 0;
    shadowParams.value.paddingTop = 0;
    shadowParams.value.position = 'center';
  }
});

watch(
  () => shadowParams.value.isShadow,
  (newVal) => {
    if (newVal === true && shadowParams.value.shadowColor === '') {
      shadowParams.value.shadowColor = '#ffffff';
    }
  },
);
watch(
  () => shadowParams.value.shadowColor,
  (newVal) => {
    if (newVal === '') {
      shadowParamsFormat.value = 0;
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["shadow-edit__settings", { 'shadow-edit__settings--mobile': _unref(isMobile) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('shadow.is-shadow')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_switch, {
          modelValue: _unref(shadowParams).isShadow,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(shadowParams).isShadow) = $event)),
          "hide-details": ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    (_unref(shadowParams).isShadow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('shadow.settings-shadow-type')), 1),
          _createVNode(_component_v_spacer),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(ShadowType, {
              modelValue: _unref(shadowParamsType),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(shadowParamsType) ? (shadowParamsType).value = $event : null))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('shadow.background-color')), 1),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(), _createBlock(ColorsList, {
          key: keyCustom.value,
          modelValue: _unref(shadowParams).shadowColor,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(shadowParams).shadowColor) = $event)),
          "no-empty-color": _unref(shadowParams).isShadow,
          "additional-colors": [{ color: '#ffffff', id: '1' }]
        }, null, 8, ["modelValue", "no-empty-color"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('shadow.settings-padding')), 1),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(AiClearButton, {
            class: _normalizeClass(["shadow-edit__settings__padding__item", { 'shadow-edit__settings__padding__item--active': _unref(shadowParams).paddingIndex === -1 }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (setPadding(-1)))
          }, {
            default: _withCtx(() => [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "shadow-edit__settings__padding__item__icon" }, null, -1)),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('shadow.bigger-size')), 1),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_text_field, {
                  modelValue: _unref(shadowParams).padding,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(shadowParams).padding) = $event)),
                  modelModifiers: { number: true, lazy: true },
                  class: "shadow-edit__input",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(AiClearButton, {
            class: _normalizeClass(["shadow-edit__settings__padding__item shadow-edit__settings__padding__item--custom", { 'shadow-edit__settings__padding__item--active': _unref(shadowParams).paddingIndex === -2 }]),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (setPadding(-2)))
          }, {
            default: _withCtx(() => [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "shadow-edit__settings__padding__item__icon" }, null, -1)),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('editor.settings.custom')), 1),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(shadowParams).paddingTop,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(shadowParams).paddingTop) = $event)),
                      modelModifiers: { number: true, lazy: true },
                      class: "shadow-edit__input",
                      "hide-details": ""
                    }, {
                      "prepend-inner": _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          style: {"min-width":"15px"},
                          src: require('@/assets/icons/shadow/padding-top.svg')
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(shadowParams).paddingRight,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(shadowParams).paddingRight) = $event)),
                      modelModifiers: { number: true, lazy: true },
                      class: "shadow-edit__input",
                      "hide-details": ""
                    }, {
                      "prepend-inner": _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          style: {"min-width":"15px"},
                          src: require('@/assets/icons/shadow/padding-right.svg')
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(shadowParams).paddingLeft,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(shadowParams).paddingLeft) = $event)),
                      modelModifiers: { number: true, lazy: true },
                      class: "shadow-edit__input",
                      "hide-details": ""
                    }, {
                      "prepend-inner": _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          style: {"min-width":"15px"},
                          src: require('@/assets/icons/shadow/padding-left.svg')
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(shadowParams).paddingBottom,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(shadowParams).paddingBottom) = $event)),
                      modelModifiers: { number: true, lazy: true },
                      class: "shadow-edit__input",
                      "hide-details": ""
                    }, {
                      "prepend-inner": _withCtx(() => [
                        _createVNode(_component_inline_svg, {
                          style: {"min-width":"15px"},
                          src: require('@/assets/icons/shadow/padding-bottom.svg')
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('common.size')), 1),
      _createElementVNode("div", _hoisted_26, [
        (_openBlock(), _createBlock(CanvasSizes, {
          key: keyCustom.value,
          height: _unref(shadowParamsCanvasHeight),
          "onUpdate:height": _cache[10] || (_cache[10] = ($event: any) => (_isRef(shadowParamsCanvasHeight) ? (shadowParamsCanvasHeight).value = $event : null)),
          width: _unref(shadowParamsCanvasWidth),
          "onUpdate:width": _cache[11] || (_cache[11] = ($event: any) => (_isRef(shadowParamsCanvasWidth) ? (shadowParamsCanvasWidth).value = $event : null))
        }, null, 8, ["height", "width"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('common.position')), 1),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(PositionList)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('shadow.settings-format')), 1),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_v_select, {
          modelValue: _unref(shadowParamsFormat),
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(shadowParamsFormat) ? (shadowParamsFormat).value = $event : null)),
          class: "shadow-edit__settings__select",
          "menu-icon": "mdi-chevron-down",
          "hide-details": "",
          items: formats.value,
          eager: ""
        }, null, 8, ["modelValue", "items"])
      ])
    ]),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(AiButton, {
          key: 1,
          disabled: _unref(generationLoading),
          theme: "gradient-primary",
          onClick: shadowFileHandler,
          style: {"width":"100%"},
          class: "shadow-edit__settings__button mt-2"
        }, {
          default: _withCtx(() => [
            (!_unref(generationLoading))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('shadow.create-shadow')), 1)
                ], 64))
              : (_openBlock(), _createBlock(TimeCounter, { key: 1 }))
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})